// export globals exposed by webpack DefinePlugin

export default {
  GIT_SHORT,
  GIT_LONG,
  GIT_DATE,
  GIT_BRANCH,
};
